import React from "react";
import { FlameIcon } from "lucide-react";
import { useOfferClock } from "../hooks/useOfferClock";
type Props = {
  tone?: "dark" | "light";
};
export function ScarcityBar({
  tone = "light"
}: Props) {
  const {
    spotsLeft,
    totalSpots
  } = useOfferClock();
  const filled = (totalSpots - spotsLeft) / totalSpots * 100;
  const isDark = tone === "dark";
  return <div className={`mt-6 rounded-2xl p-4 ${isDark ? "bg-white/10" : "bg-alert/5 ring-1 ring-alert/20"}`} data-id="element-56" data-mp="2q1o6zbyfsu4j">
      <p className={`flex items-start gap-2 text-[15px] font-bold leading-snug ${isDark ? "text-white" : "text-ink"}`} data-id="element-57" data-mp="2g5tjo3j9qavf">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-58" data-mp="226lgkzjziily" />
        <span data-id="element-59" data-mp="274vdbelcxr9o">
          Only <span className="text-alert" data-id="element-60" data-mp="274dafz46wess">{spotsLeft} spots left</span> at the promotional price
        </span>
      </p>
      <div className={`mt-3 h-4 w-full overflow-hidden rounded-full ${isDark ? "bg-white/15" : "bg-alert/15"}`} role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-61" data-mp="g0b5weqislg">
        <div className="flex h-full items-center justify-end rounded-full bg-alert pr-2 transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-62" data-mp="2zki2dyro3jaj">
          <span className="text-[10px] font-black text-white" data-id="element-63" data-mp="38empc73okaks">{Math.round(filled)}%</span>
        </div>
      </div>
      <p className={`mt-2 text-xs font-medium ${isDark ? "text-white/70" : "text-muted"}`} data-id="element-64" data-mp="2koixewzutz9m">
        {totalSpots - spotsLeft} of {totalSpots} promotional spots already claimed
      </p>
    </div>;
}